import React from 'react'
import doorImg from '../../../../images/puzzles/lastStand/openDoor.jpg'

function TheLockedDoor() {
    
    return (
        <div className='puzzleContainer'>
            <img className='puzzlePopUp_img' src={doorImg} alt='the warehouse door stands ajar' />
            <p className='puzzlePopUp_text' style={{marginBottom: '3em'}}>
                With a strong grip you force the mechanism to move, releasing the door catch. Inside you can hear raised voices, including the Professor! You creep inside and find a shadowy spot to see what's going on...
            </p>
        </div>
    )
}

export default TheLockedDoor